import { respostaNaoFormatadaByPerguntaId } from "../../utils/getRespostasNaoFormatadas";
import { formatarPeso } from "../PrimeiraConsulta/inserirRespostasSalvas";

export function insertAvaliacao(respostas, data) {
  // Avaliação/Reavaliação
  data.anamnese = respostaNaoFormatadaByPerguntaId(respostas, 1);
  data.sintomasEQueixas = respostaNaoFormatadaByPerguntaId(respostas, 232);
  data.condutaConclusaoEncaminhamentos = respostaNaoFormatadaByPerguntaId(
    respostas,
    231
  );
}

export function insertAnamneseGeral(respostas, data) {
  //Exame neuroógico - Dados gerais
  data.frequenciaCardiaca = respostaNaoFormatadaByPerguntaId(respostas, 51);
  data.pressaoArterial = respostaNaoFormatadaByPerguntaId(respostas, 52);
  data.pesoAtual = respostaNaoFormatadaByPerguntaId(respostas, 53);
  data.pesoAtual =
    data.pesoAtual === "" ? "000000" : formatarPeso(data.pesoAtual);
  data.perdaDePeso = respostaNaoFormatadaByPerguntaId(respostas, 54);
  data.fluenciaVerbal = respostaNaoFormatadaByPerguntaId(respostas, 58);
  data.rastreioComportamental = respostaNaoFormatadaByPerguntaId(respostas, 57);
  data.apatia = respostaNaoFormatadaByPerguntaId(respostas, 55);
  data.statusCognitivo = respostaNaoFormatadaByPerguntaId(respostas, 56);
  data.capacidadeVitalForcada = respostaNaoFormatadaByPerguntaId(
    respostas,
    233
  );
  data.pressaoInspiratoria = respostaNaoFormatadaByPerguntaId(respostas, 234);
  data.pressaoExpiratoria = respostaNaoFormatadaByPerguntaId(respostas, 235);
  data.pressaoNasalInspiratoria = respostaNaoFormatadaByPerguntaId(
    respostas,
    236
  );
}
